import { DashboardService } from "@/services";
import dayjs from "dayjs";
import $thousandMask from "@/mixins/thousandMask";

export default {
  name: "dashboard-transactions-card",
  components: {},
  props: [],
  mixins: [$thousandMask],
  filters: {
    dateFormat(date) {
      return dayjs(date).format("YYYY/MM/DD-HH:mm");
    }
  },
  data() {
    return {
      countPerPage: 4,
      orders: null,
      dashboardTransactionLoader: true
    };
  },
  mounted() {
    this.getOrdersData();
  },
  methods: {
    getOrdersData() {
      DashboardService.getLatestOrders(this.countPerPage)
        .then(response => {
          this.orders = response.data.data;
        })
        .finally(() => {
          this.dashboardTransactionLoader = false;
        });
    },
    statusClass(status) {
      return status + "--text";
    }
  }
};
